import React, { useEffect, useState } from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import Style from "./CreateDiscountCodeContainer.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag } from "@fortawesome/free-solid-svg-icons";
import {
  getUsersListApi,
  sendDiscountCodeApi,
} from "../../../Api/PanelAdminServices";
import Select from "react-select";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";

const CreateDiscountCodeContainer = () => {
  const [percent, setPercent] = useState(true);
  const [inputPercentValue, setInputPercentValue] = useState("");
  const [maxCart, setMaxCart] = useState("");
  const [minCart, setMinCart] = useState("");
  const [inputTomanValue, setInputTomanValue] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [userSelected, setUserSelected] = useState();
  const [allUser, setAllUser] = useState();
  const [typeState, setTypeState] = useState("percentage");

  useEffect(() => {
    getUsersList();
  }, []);
  //////////هندل کردن درصد و تومان //////////////
  const percentHandler = (e) => {
    setTypeState(e)
    if (e === "percentage") {
      setPercent(true);
      setInputPercentValue("");
      setInputTomanValue("");
    } else {
      setPercent(false);
      setInputPercentValue("");
      setInputTomanValue("");
    }
  };
  ///////////گرفتن لیست مشتریان //////////
  const getUsersList = async () => {
    getUsersListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setAllUser(res.users)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  ///////// option select users list///////
  let usersOption =
    allUser &&
    allUser.map((item) => {
      return { value: item.id, label: `${item.first_name} ${item.last_name} : ${item.id}` };
    });
  /////// onchange select option user list ////////
  const getusersOnChange = (e) => {
    setUserSelected(e.value);
  };
  /////////ارسال اطلاعات کدتخفیف //////////
  const sendDiscount = () => {
    const info = {
      user_id: userSelected,
      min_cart: minCart ? minCart : "0",
      max_cart: maxCart ? maxCart : "0",
      start_date: startDate,
      end_date: endDate,
      value: inputPercentValue ? inputPercentValue : inputTomanValue,
      type: typeState,
    };
    sendDiscountCodeApi(info, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت ایجاد شد");
      } else {
        errorToast("مشکلی پیش آمده");
      }
    });
  };
  return (
    <div>
      <TableFixedPage title={"ایجاد کد تخفیف"} />
      <div className={Style.centerHolder}>
        <section className={Style.discountPart}>
          {/* بخش اول */}
          <div className={Style.discountType}>
            <h3 className={Style.text}>نوع کد تخفیف را مشخص کنید:</h3>
            <select
              onChange={(e) => {
                percentHandler(e.target.value);
              }}
              className={Style.typeHolder}
            >
              <option value={"percentage"} className={Style.option}>
                درصد
              </option>
              <option value={"const"} className={Style.option}>
                وجه مالی
              </option>
              <option value={"shipping"} className={Style.option}>
                ارسال 
              </option>
            </select>
          </div>
          {/* بخش دوم */}
          <Select
            onChange={(e) => getusersOnChange(e)}
            options={usersOption}
            //   value={categoryFirst.filter((option) => option.value === categoryId)}
            className={Style.selectOptionsearch}
            placeholder={"انتخاب مشتری"}
          />
          {/* بخش سوم */}
          <div>
            {percent ? (
              <div className={Style.discountAmountHolder}>
                <FontAwesomeIcon className={Style.discountIcon} icon={faTag} />
                <h3 className={Style.mountTextfirst}>حداکثر مقدار سبدخرید</h3>
                <input
                  value={maxCart}
                  onChange={(e) => setMaxCart(e.target.value)}
                  className={Style.discountInput}
                />
                <h3 className={Style.mountTextSecond}> مقدار باشد</h3>
              </div>
            ) : (
              <div className={Style.discountAmountHolder}>
                <FontAwesomeIcon className={Style.discountIcon} icon={faTag} />
                <h3 className={Style.mountTextfirst}>حداقل مقدار سبد خرید</h3>
                <input
                  value={minCart}
                  onChange={(e) => setMinCart(e.target.value)}
                  className={Style.discountInput}
                />
                <h3 className={Style.mountTextSecond}>مقدار باشد</h3>
              </div>
            )}
          </div>
          {/* بخش چهارم */}
          <div>
            {percent ? (
              <div className={Style.discountAmountHolder}>
                <FontAwesomeIcon className={Style.discountIcon} icon={faTag} />
                <h3 className={Style.mountTextfirst}>به مقدار</h3>
                <input
                  value={inputPercentValue}
                  onChange={(e) => setInputPercentValue(e.target.value)}
                  className={Style.discountInput}
                />
                <h3 className={Style.mountTextSecond}>
                  درصد تخفیف روی محصولات اعمال شود
                </h3>
              </div>
            ) : (
              <div className={Style.discountTomanHolder}>
                <h3 className={Style.mountTextfirst}>
                  <FontAwesomeIcon
                    className={Style.discountIconToman}
                    icon={faTag}
                  />
                  به مقدار 
                </h3>
                <input
                  value={inputTomanValue}
                  onChange={(e) => setInputTomanValue(e.target.value)}
                  className={Style.discountToman}
                />
                <h3 className={Style.mountTextSecond}>
                   تومان تخفیف روی محصولات اعمال شود
                </h3>
              </div>
            )}
          </div>
          {/* بخش پنجم */}
          <div className={Style.datepickerHolder}>
            <label className={Style.describe}>تاریخ شروع تخفیف
            <input
              type="datetime-local"
              className={Style.timeInput}
              onChange={(e) => setStartDate(e.target.value)}
            />
            </label>
            <label className={Style.describe}>تاریخ پایان تخفیف
            <input
              type="datetime-local"
              className={Style.timeInput}
              onChange={(e) => setEndDate(e.target.value)}
            />
            </label>
          </div>
          <button className={Style.okBtn} onClick={sendDiscount}>
            ثبت
          </button>
        </section>
      </div>
    </div>
  );
};

export default CreateDiscountCodeContainer;
